import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { BaSeLoadingPage } from '@base/react';

export const AuthGuard = ({ children }) => {
  const { isAuthenticated, isInitialized, login } = Sebrae.useAuth();

  if (!isInitialized) {
    return <BaSeLoadingPage />;
  }

  if (!isAuthenticated) {
    login();
    return <BaSeLoadingPage />;
  }

  return children;
};
